import { SEOHead } from "../components/SEOHead";
import { STATIC_PAGES } from "../seo/pages";
import { PublicHeader } from "../components/PublicHeader";
import "../styles/PublicCommon.css";
import "./ServicesPage.css";

const services = [
  {
    id: "building",
    title: "建築工事",
    description: "店舗、施設、温室ハウスなど多様な建築物の新築・基礎工事を承ります。",
    image:
      "/static/%E5%BB%BA%E7%AF%89%E5%B7%A5%E4%BA%8B/%E5%BA%97%E8%88%97%E6%96%B0%E7%AF%89%E5%B7%A5%E4%BA%8B.JPG",
    details: [
      "店舗新築工事",
      "施設新築工事",
      "温室ハウス建設工事",
      "基礎工事",
      "改修・リフォーム",
    ],
    features: [
      "用途に応じた最適な設計提案",
      "確かな施工技術による高品質な仕上がり",
      "工程・品質・安全の徹底管理",
      "アフターフォローの充実",
    ],
  },
  {
    id: "demolition",
    title: "解体工事",
    description: "住宅、ビル、工場などあらゆる建築物の解体工事を承ります。",
    image:
      "/static/%E8%A7%A3%E4%BD%93%E5%B7%A5%E4%BA%8B/%E6%9C%A8%E9%80%A0%E5%AE%B6%E5%B1%8B%E8%A7%A3%E4%BD%93%E5%B7%A5%E4%BA%8B/DJI_0004.JPG",
    details: [
      "木造住宅解体",
      "鉄骨造建物解体",
      "RC造建物解体",
      "内装解体",
      "外構解体",
      "改装工事",
    ],
    features: [
      "豊富な実績による確かな技術",
      "近隣への配慮を徹底した施工",
      "産業廃棄物の適正処理",
      "安全第一の作業管理",
    ],
    additionalInfo: {
      title: "事前調査について",
      content: "解体工事、改装工事を行うには工事の規模に関わらず事前調査が必要になります。弊社は解体工事、改装工事を希望される方に事前調査を含めたご見積もりをご提案いたします。事前調査によりアスベスト含有が認められた際には別途アスベスト除去費用が発生する場合があります。その際は調査内容と施工方法についてご説明いたします。",
      certifications: [
        "NADA一般社団法人日本アスベスト調査診断協会会員",
        "特定建築物石綿含有建材調査",
      ],
    },
  },
  {
    id: "civil",
    title: "土木工事",
    description: "道路工事、上下水道工事、河川工事など各種土木工事を行います。",
    image:
      "/static/%E5%9C%9F%E6%9C%A8%E5%B7%A5%E4%BA%8B/%E6%9E%97%E9%81%93/%E5%AE%8C%E6%88%90.JPG",
    details: [
      "道路舗装工事",
      "上下水道工事",
      "河川護岸工事",
      "擁壁工事",
      "造成工事",
    ],
    features: [
      "地域の特性を考慮した施工計画",
      "最新技術と重機による効率的な作業",
      "環境への配慮",
      "確実な品質管理",
    ],
  },
  {
    id: "landscaping",
    title: "ガーデニング工事",
    description: "お庭の設計・施工から、メンテナンスまでトータルでサポートします。",
    image:
      "/static/%E3%82%AC%E3%83%BC%E3%83%87%E3%83%8B%E3%83%B3%E3%82%B0%E5%B7%A5%E4%BA%8B/%E2%97%8B%E2%97%8B%E6%A7%98%E9%82%B8%E3%82%AC%E3%83%BC%E3%83%87%E3%83%8B%E3%83%B3%E3%82%B0%E5%B7%A5%E4%BA%8B/IMG_6471.JPG",
    details: [
      "庭園設計・施工",
      "芝生張り",
      "植栽工事",
      "外構工事",
      "庭園メンテナンス",
    ],
    features: [
      "お客様のライフスタイルに合わせた提案",
      "季節を彩る植栽計画",
      "長期的な維持管理のアドバイス",
      "機能性と美しさの両立",
    ],
  },
  {
    id: "construction",
    title: "住宅等造成工事",
    description: "宅地造成、駐車場整備など、土地の有効活用をサポートします。",
    image:
      "/static/%E9%80%A0%E6%88%90%E5%B7%A5%E4%BA%8B/%E2%97%8B%E2%97%8B%E6%A7%98%E9%82%B8%E9%80%A0%E6%88%90%E5%B7%A5%E4%BA%8B/IMG_8317.JPG",
    details: [
      "宅地造成",
      "駐車場整備",
      "敷地造成",
      "整地工事",
      "排水設備工事",
    ],
    features: [
      "土地の特性を活かした造成計画",
      "法令遵守の確実な施工",
      "将来を見据えた設計提案",
      "コストパフォーマンスの追求",
    ],
  },
];

export const ServicesPage = () => {
  return (
    <>
      <SEOHead page={STATIC_PAGES.services} />

      <div className="public-page">
        <PublicHeader activePage="services" />

        {/* メインコンテンツ */}
        <main id="main-content" role="main">
          {/* ページヘッダー */}
          <section className="page-header">
            <div className="page-header-overlay" />
            <div className="page-header-content">
              <h1 className="page-title">業務内容</h1>
              <p className="page-subtitle">Our Services</p>
            </div>
          </section>

          {/* イントロセクション */}
          <section className="intro-section">
            <div className="container">
              <p className="intro-text">
                都建設株式会社は、愛媛県西予市を拠点に、<br />
                解体工事から土木工事、ガーデニング工事まで、<br />
                幅広い建設サービスを提供しています。
              </p>
              <p className="intro-text">
                長年の経験と確かな技術で、お客様のニーズにお応えします。
              </p>
            </div>
          </section>

          {/* サービス詳細セクション */}
          {services.map((service, index) => (
            <section
              key={service.id}
              className={`service-detail ${index % 2 === 1 ? "reverse" : ""}`}
              aria-labelledby={`service-${service.id}-heading`}
            >
              <div className="container-wide">
                <div className="service-layout">
                  <div className="service-image">
                    {service.image ? (
                      <img
                        src={service.image}
                        alt={`${service.title}の施工イメージ`}
                        loading="lazy"
                        style={{
                          width: "100%",
                          aspectRatio: "4 / 3",
                          objectFit: "cover",
                          borderRadius: "8px",
                          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    ) : (
                      <div
                        className="placeholder-image"
                        data-text={service.title}
                        role="img"
                        aria-label={`${service.title}の施工イメージ`}
                      />
                    )}
                  </div>

                  <div className="service-content">
                    <h2 id={`service-${service.id}-heading`} className="service-title">
                      {service.title}
                    </h2>
                    <p className="service-description">{service.description}</p>

                    <div className="service-details">
                      <h3>主な業務</h3>
                      <ul className="detail-list">
                        {service.details.map((detail, idx) => (
                          <li key={idx}>{detail}</li>
                        ))}
                      </ul>
                    </div>

                    <div className="service-features">
                      <h3>特徴</h3>
                      <ul className="feature-list">
                        {service.features.map((feature, idx) => (
                          <li key={idx}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    {service.additionalInfo && (
                      <div className="service-additional-info appear">
                        <h3 className="additional-info-title">
                          {service.additionalInfo.title}
                        </h3>
                        <p className="additional-info-content">
                          {service.additionalInfo.content}
                        </p>
                        {service.additionalInfo.certifications && (
                          <div className="certifications">
                            {service.additionalInfo.certifications.map((cert, idx) => (
                              <p key={idx} className="certification-item">
                                {cert}
                              </p>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          ))}

          {/* CTAセクション */}
          <section className="cta-section">
            <div className="container">
              <h2 className="cta-title">お見積もり・ご相談は無料です</h2>
              <p className="cta-text">
                まずはお気軽にお問い合わせください。<br />
                経験豊富なスタッフが丁寧に対応いたします。
              </p>
              <div className="cta-buttons">
                <a href="/contact" className="cta-button primary">
                  お問い合わせフォーム
                </a>
                <a href="tel:0894-62-4511" className="cta-button secondary">
                  <span>電話で問い合わせ</span>
                  <span className="phone-number">0894-62-4511</span>
                </a>
              </div>
            </div>
          </section>
        </main>

        {/* フッター */}
        <footer className="public-footer" role="contentinfo">
          <div className="footer-content">
            <div className="footer-logo">
              <img
                src="/static/miyako-logo-small-white.png"
                srcSet="/static/miyako-logo-small-white.png 1x, /static/miyako-logo-2x-white.png 2x"
                alt="都建設株式会社"
                className="footer-logo-image"
                width={60}
                height={45}
              />
              <span className="footer-company-name">都建設株式会社</span>
            </div>

            <address className="footer-address-block">
              <a
                href="https://maps.google.com/?q=愛媛県西予市宇和町卯之町1丁目432"
                className="footer-address"
                target="_blank"
                rel="noopener noreferrer"
              >
                〒797-0015 愛媛県西予市宇和町卯之町1丁目432
              </a>

              <a href="tel:0894-62-4511" className="footer-phone">
                お電話：<span itemProp="telephone">0894-62-4511</span>
              </a>
            </address>

            <nav className="footer-nav" aria-label="フッターナビゲーション">
              <a href="/">ホーム</a>
              <a href="/about">会社概要</a>
              <a href="/services">業務内容</a>
              <a href="/works">施工実績</a>
              <a href="/recruit">採用情報</a>
              <a href="/contact">お問い合わせ</a>
            </nav>

            <p className="footer-copyright">
              <small>
                ©2024 都建設株式会社 Powered by{" "}
                <a href="#" target="_blank" rel="noopener noreferrer">
                  VERYWEBB
                </a>
              </small>
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ServicesPage;
